<template>
    <div class="cliente" app>
        <Navbar/>
        
        <v-content>
            <v-overlay
                absolute
                :value="loading"
                class="text-center"
            >
                <v-progress-circular
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </v-overlay>
            <v-row align="center" justify="center" style="padding: 16px 16px; margin-top: 30px">
                <v-col cols="12" sm="11" md="10">
                    <v-card style="overflow-x:hidden" flat :dark="customization.dark">
                        <v-alert 
                            type="error"
                            :value="alert.length > 0"
                            :dark="customization.dark">
                            {{alert}}
                        </v-alert>
                        <v-form :id="`${nameType}_form`">
                            <h1 style="padding: 16px 16px">{{`Editar ${title}`}}</h1>
                            <v-row align="center" justify="center" style="padding: 16px 16px">
                                <v-col 
                                    v-for="col in cols"
                                    :key="col.value"
                                    :cols="col.cols"
                                    :sm="col.sm"
                                    :md="col.md"
                                    align="center"
                                >
                                    <v-text-field
                                        v-if="col.type == 'text'"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :rules="col.required ? requireRule : []"
                                        :value="selecionado[col.value]"
                                        :maxlength="col.length ? col.length : null"
                                        :counter="col.length"
                                        outlined
                                    ></v-text-field>
                                    <v-color-picker
                                        :style="'position: absolute; margin-top: 55px; background-color: #323232; z-index: 1000000; display: '+colorDisplay"
                                        v-if="col.type == 'color'"
                                        absolute
                                        v-model="color"
                                        mode="hexa"
                                        hide-inputs
                                    >
                                    </v-color-picker>
                                    <v-text-field
                                        v-if="col.type == 'color'"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :rules="col.required ? requireRule : []"
                                        @focus="colorDisplay = 'block'"
                                        @blur="colorDisplay = 'none'"
                                        :value="selecionado[col.value]"
                                        v-model="color.hex"
                                        outlined
                                    ></v-text-field>
                                    <v-select
                                        v-if="col.type == 'select'"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :items="Object.keys(col.items)"
                                        :value="invertObj(col.items)[selecionado[col.value]]"
                                        :name="col.value"
                                        outlined
                                    >
                                    </v-select>
                                    <v-checkbox
                                        v-if="col.type == 'check'"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :rules="col.required ? requireRule : []"
                                        :value="selecionado[col.value]"
                                        outlined
                                    ></v-checkbox>
                                    <v-text-field 
                                        v-if="col.type == 'date'"
                                        :rules="col.required ? requireRule : []"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :value="selecionado[col.value]"
                                        type="date"
                                        outlined >
                                    </v-text-field>
                                    <v-text-field 
                                        v-if="col.type == 'time'"
                                        :rules="col.required ? requireRule : []"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :value="selecionado[col.value]"
                                        type="time"
                                        outlined >
                                    </v-text-field>
                                    <v-text-field 
                                        v-if="col.type == 'password'"
                                        :rules="col.required ? requireRule : []"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :value="selecionado[col.value]"
                                        :maxlength="col.length ? col.length : null"
                                        :counter="col.length"
                                        type="password"
                                        outlined >
                                    </v-text-field>
                                    <v-text-field 
                                        v-if="col.type == 'number'"
                                        :rules="col.required ? requireRule : []"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :value="selecionado[col.value]"
                                        type="number"
                                        outlined >
                                    </v-text-field>
                                    <Autocomplete
                                        v-if="col.type == 'autocomplete'"
                                        :rules="col.required ? requireRule : []"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :dark="customization.dark"
                                        :url="col.autocomplete.url"
                                        :needWhere="col.autocomplete.needWhere"
                                        :iddisplay="col.autocomplete.display"
                                        :idvalue="col.autocomplete.value"
                                        :value="selecionado[col.value]"
                                        outlined >
                                    </Autocomplete>
                                    <Grid
                                        v-if="col.type == 'grid'"
                                        :customization="customization" 
                                        :headers="col.grid.headers"
                                        :editable="true"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :url="col.grid.url"
                                        :id_rel="col.grid.id_rel"
                                        :id_grid="col.grid.id_grid"
                                        :id="id"
                                        :needClient="col.grid.needClient">
                                    </Grid>
                                    <v-textarea
                                        v-if="col.type == 'textarea'"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :rules="col.required ? requireRule : []"
                                        :value="selecionado[col.value]"
                                        :maxlength="col.length ? col.length : null"
                                        :counter="col.length"
                                        outlined
                                    ></v-textarea>
                                    <File
                                        v-if="col.type == 'fileIcon'"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :dark="customization.dark"
                                        :mainColor="customization.mainBtnColor"
                                        :value="selecionado[col.value]"
                                        outlined
                                    ></File>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card>
                </v-col>
            </v-row>

            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                    fixed
                    dark
                    fab
                    right
                    color='red'
                    style="bottom: 85px"
                    v-on="on"
                    @click="back"
                    >
                        <v-icon>mdi-cancel</v-icon>
                    </v-btn>
                </template>
                <span>Cancelar</span>
            </v-tooltip>

            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                    fixed
                    dark
                    fab
                    right
                    color='green'
                    style="bottom: 15px"
                    v-on="on"
                    @click="salvar"
                    >
                        <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                </template>
                <span>Salvar</span>
            </v-tooltip>
        </v-content>
    </div>
</template>

<style scoped>

</style>

<script>
import Autocomplete     from '@/components/Autocomplete.vue';
import Grid             from '@/components/Grid.vue';
import Navbar           from '@/components/Navbar.vue';
import File             from '@/components/File.vue';
import api              from '@/plugins/apisauceHeader.js';
import router           from '@/router/index.js';
import CRUD             from '@/assets/CRUD.json';

export default {
    name: 'Edit',
    components:{
        Navbar,
        Autocomplete,
        Grid,
        File
    },
    data(){
        return{
            id: null,
            selecionado: {},
            alert: "",
            requireRule:[
                r => (r && r.toString().length > 0 ) || "Essa campo é obrigatório!"
            ],
            loading: false,
            dialog_remove: false,
            customization: {},
            nameType: "",
            cols: [],
            color: {hex: "#ff0000"},
            colorDisplay: "none",
            date: {},
            title: ""
        }
    },
    methods:{
        invertObj(obj){
            const result = {};
            Object.keys(obj).forEach(o=>{
                result[obj[o]] = o;
            });
            return result;
        },
        back(){
            router.push(`/View/${this.nameType}/${this.id}`);
        },
        salvar(){
            let grids = [];
            let gridsUrl = [];
            const form = document.getElementById(`${this.nameType}_form`);
            const rows = {};
            let p = true;

            this.cols.forEach(c=>{
                if(c.required && form[c.value].value == ""){ 
                    p = false;
                    if(c.type == "select")
                        form[c.value].click();
                    else if(c.type == "autocomplete"){
                        form[c.value+"_input"][0].click();
                        this.alert = "Você precisa preencher o campo "+c.value;
                        window.scrollTo(0,0);
                    }else
                        form[c.value].focus();
                }
                switch(c.type){
                    case "check":
                        if(c.value == "deletado_veiculo")
                            rows["deletado"] = (form[c.value].checked ? "Sim" : "Não");
                        else
                            rows[c.value] = (form[c.value].checked ? "1" : "0");
                    break;
                    case "select":
                        rows[c.value] = `${c.items[form[c.value].value]}`;
                    break;
                    case "grid":
                        grids.push(JSON.parse(form[c.value].value));
                        gridsUrl.push({url: c.grid.url, id_rel: c.grid.id_rel, id: c.grid.id});
                        grids.push(JSON.parse(form[`${c.value}_removed`].value));
                        gridsUrl.push({url: c.grid.url, id_rel: c.grid.id_rel, id: c.grid.id, delete: true, deactivate: c.grid.deactivate, active_grid: c.grid.active_grid});
                    break;
                    case "number":
                        rows[c.value] = rows[c.value] != "" ? `${form[c.value].value}` : `null`;
                    break;
                    default:
                        rows[c.value] = `${form[c.value].value}`;
                        if(c.type == "autocomplete" && form[c.value].value == "")
                            delete rows[c.value];
                    break;
                }
            });
            
            if(p){
                this.loading = true;
                api(localStorage.getItem("token")).put(`endpoint${CRUD[this.nameType].endpoint}/${this.id}`,rows).then(r=>{
                    if(r.ok)
                        this.applyGrid(gridsUrl,grids,0,this.id,0);
                    else
                        this.alert = r.data.mensagem; 
                });
            }
        },
        applyGrid(gridsUrl,grids,n,id,i){
            if(n >= grids.length){
                this.loading = false;
                this.back();
            }else{
                if(grids[n].length > 0){
                    if(i < grids[n].length){
                        const rows = grids[n][i];
                        let url = gridsUrl[n].url;
                        if(gridsUrl[n].delete){
                            if(gridsUrl[n].deactivate){
                                const idUrl = rows;
                                let rows_delete = {};
                                rows_delete[gridsUrl[n].active_grid] = '0';
                                rows_delete[gridsUrl[n].id] = rows;
                                api(localStorage.getItem("token")).put(`endpoint/${url}/${idUrl}`, rows_delete).then(r=>{
                                    if(r.ok)
                                        this.applyGrid(gridsUrl,grids,n,id,i+1);
                                    else{
                                        this.alert = "Erro ao salvar a grid !!"; 
                                        this.loading = false;
                                        window.scrollTo(0,0);
                                    }
                                });
                            }else{ 
                                let url = gridsUrl[n].url;
                                api(localStorage.getItem("token")).delete(`endpoint/${url}/${rows}`).then(r=>{
                                    if(r.ok)
                                        this.applyGrid(gridsUrl,grids,n,id,i+1);
                                    else {
                                        this.alert = r.data.mensagem; 
                                        this.loading = false;
                                    }
                                })
                            }
                        }else{
                            if(rows[gridsUrl[n].id]){
                                const idUrl = rows[gridsUrl[n].id];
                                delete rows[gridsUrl[n].id];
                                delete rows['lastupdate'];
                                rows[gridsUrl[n].id_rel] = id;
                                if(rows['idmotorista_grid']){
                                    rows['idmotorista'] = rows['idmotorista_grid'];
                                    delete rows['idmotorista_grid'];
                                }
                                api(localStorage.getItem("token")).put(`endpoint/${url}/${idUrl}`,rows).then(r=>{
                                    if(r.ok)
                                        this.applyGrid(gridsUrl,grids,n,id,i+1);
                                    else{
                                        this.alert = "Erro ao salvar a grid! verifique se todos os campos estão preenchidos!"; 
                                        this.loading = false;
                                        window.scrollTo(0,0);
                                    }
                                });
                            }else{
                                rows[gridsUrl[n].id] = "#uuid()";
                                rows[gridsUrl[n].id_rel] = id;
                                if(rows['idmotorista_grid']){
                                    rows['idmotorista'] = rows['idmotorista_grid'];
                                    delete rows['idmotorista_grid'];
                                }
                                api(localStorage.getItem("token")).post(`endpoint/${url}/`,rows).then(r=>{
                                    if(r.ok)
                                        this.applyGrid(gridsUrl,grids,n,id,i+1);
                                    else{
                                        this.alert =  "Erro ao salvar a grid! verifique se todos os campos estão preenchidos!";
                                        this.loading = false;
                                        window.scrollTo(0,0);
                                    }
                                });
                            }
                        }
                    }else
                        this.applyGrid(gridsUrl,grids,n+1,id,0);
                }else 
                    this.applyGrid(gridsUrl,grids,n+1,id,0);
            }
        },
        get(){
            this.loading = true;
            api(localStorage.getItem("token")).get(`one/endpoint${this.endpoint}/${this.id}`).then(r=>{
                if(r.ok)
                    this.selecionado = r.data[0];

                this.cols.forEach(c=>{
                    if(c.type == "date")
                        this.date[c.value] = r.data[0][c.value];
                    else if(c.type == "color")
                        this.color.hex = r.data[0][c.value];
                })

                this.loading = false;
            })
        }
    },
    mounted(){
        this.customization = JSON.parse(localStorage.getItem("customization"));
        this.nameType   = this.$route.params.nameType;
        this.id         = this.$route.params.id;
        this.endpoint = `${CRUD[this.nameType].endpoint}`;
        if(!CRUD[this.nameType]) router.push('/dashboard');

        this.title = `${CRUD[this.nameType].label ? CRUD[this.nameType].label : this.nameType}`;
        document.title = `${this.customization.name} - Editar ${this.title}`;
        if(!localStorage.getItem("usrId")) router.push('/');
        this.cols = CRUD[this.nameType].cols;

        this.get();
    }
}
</script>